import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { AppReducer } from './AppReducer';
import { EmployeeReducer } from './EmployeeReducer';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { LeaveManagementReducer } from './LeaveManagementReducer';

const rootReducer = combineReducers({
  appReducer: AppReducer,
  employeeReducer: EmployeeReducer,
  leaveManagementReducer: LeaveManagementReducer
});

const persistConfig = {
  key: 'root',
  storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
});

export const persistor = persistStore(store);

export type RootStateType = ReturnType<typeof store.getState>;
